/* eslint-disable react/prop-types */
import React from 'react'
import PrescriptionItem from './PrescriptionItem';
import RequestMdmImagesButton from './RequestMdmImagesButton';
import { validateOrderAndPrescriptionItems } from '../../../utils/orderUtils';
import { isNil } from 'lodash';
import { getMedicineQuantity } from '../../../utils/generateRows';

export default function PrescriptionItems({ order, refetch, addItem, deleteItem, Items, updateItem }) {
    if (order && Items) {
        for (let key in Items) Items[key].messages = [];
        let verify = validateOrderAndPrescriptionItems(order, Items);
        if (!verify.success) {
            for (let message of verify.messages) {
                if (message.data?.id?.includes(':')) continue;
                if (isNil(message?.data)) {
                    for (let key in Items) {
                        Items[key].messages.push(message)
                    }
                    continue;
                }
                if (Items[message.data.id]?.messages?.length > 0) Items[message.data.id].messages.push(message)
                else Items[message.data.id].messages = [message]
            }
        }
    }

    let dispensedTotal = 0;
    for (const key in Items) {
        if (key.includes(':')) continue;
        const item = Items[key];
        if (item?.typeOfAdmin === 'AS_PER_PRESCRIPTION') continue;
        const usedQty = getMedicineQuantity(item);
        const invoiceItems = item?.invoiceItems || [];
        const totalBilledAmt = invoiceItems.reduce((acc, i) => acc + (i.amount || 0), 0);
        const totalBilledQty = invoiceItems.reduce((acc, i) => acc + (i.quantity || 0), 0);
        if (usedQty > 0 && totalBilledQty > 0) {
            dispensedTotal += (totalBilledAmt / totalBilledQty) * usedQty;
        } else {
            dispensedTotal += totalBilledAmt;
        }
    }
    const billedTotal = order?.total || 0;
    const hasPartialDispense = Math.abs(dispensedTotal - billedTotal) > 0.01;

    return (
        <div id="prescriptionItems" className='grow flex flex-col gap-5'>
            <RequestMdmImagesButton Items={Items} />
            {hasPartialDispense && (
                <div className='flex gap-6 p-3 bg-gray-50 border border-gray-200 rounded-xl text-sm'>
                    <div>
                        <span className='text-gray-500 font-medium'>Billed Total: </span>
                        <span className='font-semibold text-gray-800'>
                            {billedTotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 })}
                        </span>
                    </div>
                    <div>
                        <span className='text-orange-500 font-medium'>Dispensed Total: </span>
                        <span className='font-semibold text-orange-600'>
                            {dispensedTotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 })}
                            {' '}({Math.round(dispensedTotal).toLocaleString('en-IN')})
                        </span>
                    </div>
                </div>
            )}
            {
                Object.keys(Items).sort((a, b) => { return parseInt(Items[a]?.itemId) - parseInt(Items[b]?.itemId) }).map((itemId) => {
                    return (
                        <PrescriptionItem order={order} refetch={refetch} addItem={addItem} deleteItem={deleteItem} updateItem={updateItem} key={itemId} itemId={itemId} Items={Items} userTimings={order.userTimings} />
                    )
                })
            }
        </div>
    )
}
